
import React, { lazy } from 'react'
import Form from "../components/Form";

const Calculator = lazy(() => import('../components/Calculator'));
const Faq = lazy(() => import('../components/Faq'));
const Featuresbenefits = lazy(() => import('../components/Featuresbenefits'));
const Homeloantype = lazy(() => import('../components/Homeloantype'));
const Benefits = lazy(() => import('../components/Benefits'));

function Home() {

  return (
    <>
    <Form />
    {/* <Calculator /> */}
    <Featuresbenefits />
    <Benefits />
    <Homeloantype />
      <Faq />

    </>
  );
}

export default Home;
